<template>
  <svg :width="width" :height="height" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.125 5.36683C15.5583 2.49183 13.0333 0.333496 10 0.333496C7.59167 0.333496 5.5 1.70016 4.45833 3.70016C1.95 3.96683 0 6.09183 0 8.66683C0 11.4252 2.24167 13.6668 5 13.6668H15.8333C18.1333 13.6668 20 11.8002 20 9.50016C20 7.30016 18.2917 5.51683 16.125 5.36683ZM11.6667 7.8335V11.1668H8.33333V7.8335H5.83333L10 3.66683L14.1667 7.8335H11.6667Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'IconUpload',

  props: {
    fill: {
      type: String,
      default: '#00d26e'
    },

    width: {
      type: String,
      default: '20px'
    },

    height: {
      type: String,
      default: '14px'
    }
  }
};
</script>
